/**
 * Shared Audio Clue note registry for Higher or Lower.
 * action_key is used in game_sound_configs; name is the musical label.
 * Keep in sync with server/constants/audioClueNotes.js
 */
export const AUDIO_CLUE_NOTES = [
  { name: "C3", action_key: "clue_c3" },
  { name: "C#3", action_key: "clue_cs3" },
  { name: "D3", action_key: "clue_d3" },
  { name: "D#3", action_key: "clue_ds3" },
  { name: "E3", action_key: "clue_e3" },
  { name: "F3", action_key: "clue_f3" },
  { name: "F#3", action_key: "clue_fs3" },
  { name: "G3", action_key: "clue_g3" },
  { name: "G#3", action_key: "clue_gs3" },
  { name: "A3", action_key: "clue_a3" },
  { name: "A#3", action_key: "clue_as3" },
  { name: "B3", action_key: "clue_b3" },
];

export const AUDIO_CLUE_SOUND_DEFINITIONS = AUDIO_CLUE_NOTES.map((note) => ({
  action_key: note.action_key,
  label: `Audio Clue: ${note.name}`,
  loop: false,
  default_volume: 0.8,
}));

export const NOTES = AUDIO_CLUE_NOTES.map((n) => n.name);

export function noteToActionKey(noteName) {
  const found = AUDIO_CLUE_NOTES.find((n) => n.name === noteName);
  return found?.action_key || null;
}
